import { useState, useEffect, useContext } from "react";
import "./styles.css";
import { Images } from "../../theme";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../context/GlobalContext";
import { DotsLoader, NoDataFound } from "../../components";

export default function RentalsItems(props) {
  const getContextItem = useContext(GlobalContext);
  let { get_item_by_user_id, userAllItemData, imageUrl, isLoading } =
    getContextItem;
  const { t } = useTranslation();

  useEffect(() => {
    get_item_by_user_id();
  }, []);

  return (
    <div className="mb-3">
      {isLoading ? (
        <DotsLoader />
      ) : userAllItemData.length ? (
        userAllItemData?.map((OwnerData, index) => {

          return (
            <div className="col-md-12 mt-5">
              <div className="row mainBoxShadow">
                <div className="col-md-3 col-12">
                  <img
                    src={
                      OwnerData?.images?.length
                        ? `${imageUrl}${OwnerData?.images[0]}`
                        : Images.productImg
                    }
                    alt="image"
                    className="imgOwnProduct"
                  />
                </div>
                <div className="col-md-6 col-12">
                  <span className="OwnerHeading">
                    {t("Owner")} {props.loginData?.firstname}{" "}
                    {props.loginData?.lastname}
                  </span>
                  <br />
                  <span className="OwnerProduct">{OwnerData.title}</span>
                  <p className="OwnerHeading">{OwnerData.description}</p>
                  <p className="OwnerHeading">{OwnerData.category}</p>
                  <div>
                    <img src={Images.ratingIcon} alt="image" />
                    <span className="ratingOwerText">4.8</span>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="OwerlocationRight">
                    <img
                      className="locationIcon"
                      src={Images.locationIcon}
                      alt="image"
                    />{" "}
                    <span className="OwerlocationText">
                      {OwnerData.location}
                    </span>
                    <p className="priceRentals">${OwnerData.daily_price}</p>
                    <p className="priceRentals"></p>
                    <div className="btMainDivRentals">
                      <Link to="/Listanitem" state={{ item: OwnerData }}>
                        <button class="btn-custom btn-light">
                          {t("Edit_Item")}
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <NoDataFound />
      )}
    </div>
  );
}
